import { ApplicationContextState } from '@/store/modules/application-context/types/application-context.types';

export const applicationContextState: ApplicationContextState = {
  apiState: {},
  applicationContext: undefined
};
